import React from "react";
import {
  Paper,
  Stack,
  Text,
  Title,
  Group,
  Divider,
  Box,
} from "@mantine/core";
import { IconExternalLink } from "@tabler/icons-react";

export default function PreviewPanel({ globalState }) {
  return (
    <Paper 
      p="lg" 
      withBorder 
      radius="md" 
      style={{ 
        backgroundColor: '#fff', 
        height: 'calc(100vh - 250px)',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      {/* Preview Header */}
      <Group justify="space-between" mb="md">
        <div>
          <Title order={4}>Preview Area</Title>
          <Text size="xs" c="dimmed">Verification UI preview will appear here</Text>
        </div>
      </Group>

      <Divider mb="md" />

      {/* Placeholder Container */}
      <Box 
        style={{ 
          flex: 1,
          backgroundColor: '#f8f9fa',
          borderRadius: '8px',
          padding: '20px',
          overflow: 'auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Stack align="center" gap="md">
          <Box
            style={{
              width: '120px',
              height: '120px',
              borderRadius: '12px',
              border: '2px dashed #dee2e6',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#fff'
            }}
          >
            <IconExternalLink size={48} color="#adb5bd" />
          </Box>
          <Stack gap="xs" align="center">
            <Text size="lg" fw={500} c="dark.3">Preview Placeholder</Text>
            <Text size="sm" c="dimmed" ta="center">
              The verification experience preview will appear here
            </Text>
            <Text size="xs" c="dimmed" ta="center">
              Configure settings on the left to customize the verification journey
            </Text>
          </Stack>
        </Stack>
      </Box>
    </Paper>
  );
}